import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';

export interface UploadFile {
  fileName: string;
  fileType: string;
  fileSize: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fileBytes: any;
}

export interface ModalUploadItemDialogData {
  failedUpload?: boolean;
  fileData?: UploadFile;
}

@Component({
  selector: 'app-modal-upload-file',
  templateUrl: './modal-upload-file.component.html',
  styleUrls: ['./modal-upload-file.component.scss'],
  standalone: false,
})
export class ModalUploadFileComponent extends Loggable implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);

  protected fileSelected = false;
  protected fileData!: UploadFile;

  protected uploadedFailed = false;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalUploadItemDialogData,
    public dialogRef: MatDialogRef<ModalUploadFileComponent>,
  ) {
    super();
    this.setDisplayName('ModalUploadFileComponent');

    if (this.data && this.data.failedUpload && this.data.fileData) {
      this.uploadedFailed = this.data.failedUpload;
      this.fileData = this.data.fileData;
      this.fileSelected = true;
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public close(): void {
    this.dialogRef.close();
  }

  public selectFile(event: Event): void {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        this.fileData = {
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          fileBytes: reader.result,
        };
        this.fileSelected = true;
      };
    }
  }

  public removeFile(): void {
    this.fileData = {
      fileName: '',
      fileType: '',
      fileSize: 0,
      fileBytes: undefined,
    };
    this.fileSelected = false;
    this.uploadedFailed = false;
  }

  public uploadFile(): void {
    this.dialogRef.close(this.fileData);
  }
}
